import { Box } from '@mui/material'
import React from 'react'

const InformationIcon = ({ icon, text }: any) => (
  <Box
    component="div"
    sx={{
      display: 'flex',
      flexDirection: 'row',
      fontWeight: 'normal',
      alignItems: 'center',
      gap: '5px',
      alignSelf: 'flex-end',
    }}
  >
    {icon}
    <span>{text}</span>
  </Box>
)

export default InformationIcon
